import React from "react";
import { Check, Monitor, Moon, Sun } from "lucide-react";
import "./AccountExperience.css";

function Miniature({ dark }) {
  return <div className={`appearance-mini ${dark ? "mini-dark" : "mini-light"}`} aria-hidden="true">
    <div className="mini-sidebar"><i /><i /><i /></div>
    <div className="mini-chat"><i /><i /><i /><b /></div>
  </div>;
}

export default function AppearanceSettings({ mode, onChange }) {
  return <section className="settings-section appearance-settings">
    <h3>外观</h3>
    <fieldset><legend>主题模式</legend><div className="appearance-options">
      {[{ id: "system", label: "跟随系统", Icon: Monitor }, { id: "light", label: "浅色", Icon: Sun }, { id: "dark", label: "深色", Icon: Moon }].map(({ id, label, Icon }) =>
        <label key={id} className={`appearance-option ${mode === id ? "selected" : ""}`}>
          <input type="radio" name="theme-mode" value={id} checked={mode === id} onChange={(event) => onChange(id, event)} />
          <span className={`appearance-thumbnail ${id === "system" ? "appearance-split" : ""}`}>
            {id === "system" ? <><Miniature dark={false} /><Miniature dark /></> : <Miniature dark={id === "dark"} />}
            {mode === id && <span className="appearance-check"><Check size={12} /></span>}
          </span>
          <span className="appearance-label"><Icon size={14} />{label}</span>
        </label>)}
    </div></fieldset>
  </section>;
}
